import type { PropsWithChildren } from "react";
import { Component } from "react";
import { InternalErrorPage } from "./500";

interface IErrorBoundaryProps {
  // void
  [key: string]: any;
}
interface IErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}
export class ErrorBoundary extends Component<
  PropsWithChildren<IErrorBoundaryProps>,
  IErrorBoundaryState
> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: any) {
    this.setState({ error });
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    // logErrorToMyService(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <InternalErrorPage error={this.state.error} />;
    }

    return this.props.children;
  }
}
